import Head from 'next/head'

export function NoIndexHeader() {
  return (
    <Head>
      <meta name='robots' content='noindex,nofollow' />
    </Head>
  )
}
